import type { IDocument } from "@bbj-types/document";
import type { IFupLogo } from "@bbj-types/organisation";
import type { IFupPartnerFeedback } from "@bbj-types/socialApply/fup";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "../axios";

export interface IPatchSendFupToOperatorBody {
  partnerFeedback: IFupPartnerFeedback;
  sponsorsLogo: Pick<IFupLogo, "label" | "uri">[];
}

export interface IPatchSendFupToOperatorResponse {
  document: IDocument;
}

export const usePatchSendFupToOperator = () => {
  const [state, execute, cancel] = axios<IPatchSendFupToOperatorResponse, IPatchSendFupToOperatorBody, unknown>(
    {
      url: "/applies/social/:id/fup/operator",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId, data: IPatchSendFupToOperatorBody) => {
      return execute({
        url: `/applies/social/${id}/fup/operator`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
